import { registerHandler } from '../paymentHandlerRegistry';
import adyen from '../../../../../payments/core/engines/adyen';
import availablePaymentEngines from '../../../../constants/PaymentEngine';

/**
 * Adyen credit card handler.
 * Trigger the Adyen Web Components form submission so the SDK encrypts card data
 * and fires its onSubmit callback (which dispatches cardPaymentAttempt via useAdyen).
 */
const adyenCreditCardPaymentHandler = {
  canHandle: ({ paymentEngine, env }) =>
    paymentEngine === availablePaymentEngines.adyen && Boolean(env?.adyen?.enabled),

  execute: async ({ onNoCardSelected }) => {
    const adyenInstance = adyen.getAdyenInstance();
    if (!adyenInstance) {
      onNoCardSelected?.();
      return;
    }
    adyenInstance.submit();
  },
};

registerHandler('credit_card', adyenCreditCardPaymentHandler);
